import React from 'react'
import styled, { css } from 'styled-components'
import { Text } from 'lib/Text'
import { TooltipText } from './TooltipText'

const Container = styled.div<{ $fill?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: var(--spacing);
  ${(props) =>
    props.$fill &&
    css`
      flex-basis: 100%;
      flex-grow: 1;
    `}
`

const Hint = styled(Text)`
  margin-top: 4px;
`

const Optional = styled(Text)`
  margin-left: 4px;
  vertical-align: middle;
`

interface Props {
  children: React.ReactNode
  className?: string
  fill?: boolean
  label?: string
  hint?: React.ReactNode | string
  useLabelTag?: boolean
  required?: boolean
  optional?: boolean
  onClick?: () => void
  compact?: boolean
}

export const FormField = ({ children, compact = false, className, hint, fill, label, useLabelTag = true, required, optional, onClick }: Props) => (
  <Container className={className} onClick={onClick} $fill={fill}>
    <Text as={useLabelTag ? 'label' : 'div'} weight="medium" size={compact ? 'pxs' : 'ps'} color="neutral-100">
      {label}
      {optional && (
        <Optional size="small" as="span" color="neutral-40">
          optional
        </Optional>
      )}
      {required && (
        <TooltipText content="Required">
          <span>*</span>
        </TooltipText>
      )}
      {children}
    </Text>
    {hint && (
      <Hint weight="regular" size="small" color="neutral-60">
        {hint}
      </Hint>
    )}
  </Container>
)
